import {
    FilterContainer,
    FilterDetailsContainer,
    ExtraContainer,
    FilterStringWithPipe,
    Counter,
    CounterNumber,
    ClearFilterDesktop,
    FilterOptionSelect,
    ViewContainer,
} from './FilterResultsPanel.styled';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { openFilterPopover,setNotificationFailure } from 'src/pages/orders/redux/actions';
import { dynamicPluralization, isMobileDevice, isLandscape } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const FilterResultsPanel = (props) => {
    {
        /*Pass in the appliedViews or appliedFilters as an array of selected filters from respective stores of parent component   */
    }
    const {
        appliedViews = [],
        appliedFilters = [],
        clearFilterHandler,
        resetHandler=()=>{},
        marginLeftTemplate,
        widthTemplate,
        mobWidthTemplate,
        backgroundColor = '#f5f5f5',
        mobileBackgroundColor = '#f5f5f5',
        filtersList,
        setClearFilterClicked,
        marginBottomTemplate,
        dateFilter = false,
        fimDashboardFilterResultsPanel = false,
        clearFilterFlag= true
    } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth,
    });
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const [viewOverflow, setViewOverflow] = useState(false);
    const [filterOverflow, setFilterOverflow] = useState(false);
    const filterRef = useRef('');
    const viewRef = useRef('');

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        if (viewRef.current && viewRef.current.scrollWidth) {
            setViewOverflow(
                !(viewRef.current.scrollWidth <= viewRef.current.clientWidth)
            );
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        if (filterRef.current && filterRef.current.scrollWidth) {
            setFilterOverflow(
                !(
                    filterRef.current.scrollWidth <=
                    filterRef.current.clientWidth
                )
            );
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    useEffectWithErrorLogging(() => {
        if (viewRef.current && viewRef.current.scrollWidth) {
            setViewOverflow(
                !(viewRef.current.scrollWidth <= viewRef.current.clientWidth)
            );
        }
        if (filterRef.current && filterRef.current.scrollWidth) {
            setFilterOverflow(
                !(
                    filterRef.current.scrollWidth <=
                    filterRef.current.clientWidth
                )
            );
        }
    }, [dimensions]);

    // Clear filter handler function
    const handleClearClick = () => {
         dispatch(setNotificationFailure([{ description: "Notification Failure", isChecked: false, statusCode: "NOTIFICATION_FAILURE" }]));
        if (setClearFilterClicked) {
            setClearFilterClicked(true);
        }
        if (clearFilterHandler) {
            clearFilterHandler();
        }
        if (resetHandler) {
            resetHandler();
        }
    };

    let viewString = '';
    const maxVisible = isMobileDevice() ? 1 : 3;
    const visibleViews = Array.isArray(appliedViews)
        ? appliedViews.slice(0, maxVisible)
        : [];
    Array.isArray(visibleViews) &&
        visibleViews.map((filter, index) => {
            if (index < visibleViews.length - 1) {
                viewString += `${filter} | `;
            } else {
                viewString += `${filter} `;
            }
        });

    // Sales Organization View Logic
    let salesOrgViewString = '';
    if (filtersList && Array.isArray(filtersList)) {
        filtersList
            .filter(
                (itemData) =>
                    (itemData.isChecked ||
                        (!Object.prototype.hasOwnProperty.call(
                            itemData,
                            'isChecked'
                        ) &&
                            itemData.isDefault)) &&
                    itemData.value !== 'All'
            )
            .forEach((item, filterIndex) => {
                if (
                    item.isChecked ||
                    (!Object.prototype.hasOwnProperty.call(item, 'isChecked') &&
                        item.isDefault)
                ) {
                    salesOrgViewString += `${item.name} `;
                    const filteredItems = filtersList.filter(
                        (itemData) =>
                            (itemData.isChecked ||
                                (!Object.prototype.hasOwnProperty.call(
                                    itemData,
                                    'isChecked'
                                ) &&
                                    itemData.isDefault)) &&
                            itemData.value !== 'All'
                    );
                    if (
                        filteredItems.length > 1 &&
                        filteredItems.length - 1 !== filterIndex
                    ) {
                        salesOrgViewString += '| ';
                    }
                }
            });
    }

    let filterString = '';
    const visibleFilters = Array.isArray(appliedFilters)
        ? appliedFilters.slice(0, maxVisible)
        : [];
    Array.isArray(visibleFilters) &&
        visibleFilters.map((filter, index) => {
            if (index < visibleFilters.length - 1) {
                filterString += `${filter} | `;
            } else {
                filterString += `${filter} `;
            }
        });

    return (
        <>
            {(Array.isArray(appliedViews) ? appliedViews.length : 0) ||
            (Array.isArray(appliedFilters) ? appliedFilters.length : 0) ||
            salesOrgViewString ? (
                <FilterOptionSelect
                    widthTemplate={widthTemplate}
                    mobWidthTemplate={mobWidthTemplate}
                    fimDashboardFilterResultsPanel={fimDashboardFilterResultsPanel}
                >
                    <Grid
                        container
                        justifyContent={'space-between'}
                        direction="row"
                        alignContent="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            lg={10}
                            xl={10}
                            mobile={12}
                        >
                            <FilterContainer
                                backgroundColor={backgroundColor}
                                mobileBackgroundColor={mobileBackgroundColor}
                                {...props}
                            >
                                {/* Sales Organization View */}
                                {salesOrgViewString ? (
                                    <ViewContainer
                                        {...props}
                                        style={{
                                            margin: '0',
                                            wordBreak:
                                                isLanguageChanged && 'keep-all',
                                        }}
                                    >
                                        {t(
                                            'calendar.filterResultsPanel.viewLabel'
                                        )}
                                        : {/* check this */}
                                        <Grid
                                            item
                                            xs={9}
                                            sm={9}
                                            md={9}
                                            lg={12}
                                            xl={9}
                                            mobile={9}
                                        >
                                            <FilterStringWithPipe
                                                mbViewWidth
                                                ref={viewRef}
                                                {...props}
                                            >
                                                {salesOrgViewString}
                                            </FilterStringWithPipe>
                                        </Grid>
                                    </ViewContainer>
                                ) : null}

                                {appliedViews && appliedViews.length ? (
                                    <FilterDetailsContainer
                                        marginTop={
                                            appliedViews?.length > 0 &&
                                            isMobileDevice()
                                                ? isLandscape()
                                                    ? '0px'
                                                    : '15px'
                                                : '0'
                                        }
                                        mobileWidth={props.mobileWidth}
                                        containerMargin={'0 5px 0 0px'}
                                        {...props}
                                    >
                                        {viewString && (
                                            <>
                                                <div
                                                    style={{
                                                        wordBreak:
                                                            isLanguageChanged &&
                                                            'keep-all',
                                                    }}
                                                >
                                                    {appliedViews.length
                                                        ? `${dynamicPluralization(
                                                              t(
                                                                  'calendar.filterResultsPanel.viewLabel'
                                                              ),
                                                              t(
                                                                  'calendar.filterResultsPanel.viewsLabel'
                                                              ),
                                                              appliedViews.length
                                                          )}  (${
                                                              appliedViews.length
                                                          }) : `
                                                        : null}
                                                </div>
                                                <FilterStringWithPipe
                                                    ref={viewRef}
                                                >
                                                    {viewString}
                                                </FilterStringWithPipe>
                                            </>
                                        )}

                                        {appliedViews.length <= maxVisible &&
                                            viewOverflow && (
                                                <ExtraContainer
                                                    {...props}
                                                    onClick={(e) => {
                                                        if (props.onMoreClick) {
                                                            props.onMoreClick(
                                                                e
                                                            );
                                                            return;
                                                        }
                                                        dispatch(
                                                            openFilterPopover({
                                                                isSet: true,
                                                                isShowView: true,
                                                                isShowFilter: false,
                                                            })
                                                        );
                                                    }}
                                                >
                                                    {t('common.moreLabel')}
                                                </ExtraContainer>
                                            )}

                                        {appliedViews.length > maxVisible && (
                                            <ExtraContainer
                                                {...props}
                                                onClick={(e) => {
                                                    if (props.onMoreClick) {
                                                        props.onMoreClick(e);
                                                        return;
                                                    }
                                                    dispatch(
                                                        openFilterPopover({
                                                            isSet: true,
                                                            isShowView: true,
                                                            isShowFilter: false,
                                                        })
                                                    );
                                                }}
                                            >
                                                <Counter>
                                                    <CounterNumber>
                                                        {`+ ${
                                                            appliedViews.length -
                                                            maxVisible
                                                        }`}
                                                    </CounterNumber>
                                                </Counter>
                                            </ExtraContainer>
                                        )}
                                    </FilterDetailsContainer>
                                ) : null}

                                {appliedFilters && appliedFilters.length ? (
                                    <FilterDetailsContainer
                                        {...props}
                                        mobileWidth={props.mobileWidth}
                                    >
                                        <>
                                            <>
                                                {appliedFilters.length &&
                                                !props.isTemplate
                                                    ? `${dynamicPluralization(
                                                          t(
                                                              'calendar.filterResultsPanel.filterLabel'
                                                          ),
                                                          t(
                                                              'calendar.filterResultsPanel.filtersLabel'
                                                          ),
                                                          appliedFilters.length
                                                      )}  (${
                                                          appliedFilters.length
                                                      }) : `
                                                    : null}
                                            </>
                                            {!props.isTemplate && (
                                                <FilterStringWithPipe
                                                    ref={filterRef}
                                                    {...props}
                                                >
                                                    {filterString}
                                                </FilterStringWithPipe>
                                            )}
                                        </>
                                        {appliedFilters.length <= maxVisible &&
                                            filterOverflow &&
                                            !props.isTemplate && (
                                                <ExtraContainer
                                                    {...props}
                                                    onClick={(e) => {
                                                        if (props.onMoreClick) {
                                                            props.onMoreClick(
                                                                e
                                                            );
                                                            return;
                                                        }
                                                        dispatch(
                                                            openFilterPopover({
                                                                isSet: true,
                                                                isShowView: false,
                                                                isShowFilter: true,
                                                            })
                                                        );
                                                    }}
                                                >
                                                    {t('common.moreLabel')}
                                                </ExtraContainer>
                                            )}
                                        {appliedFilters.length > maxVisible &&
                                            !props.isTemplate && (
                                                <ExtraContainer
                                                    {...props}
                                                    onClick={(e) => {
                                                        if (props.onMoreClick) {
                                                            props.onMoreClick(
                                                                e
                                                            );
                                                            return;
                                                        }
                                                        dispatch(
                                                            openFilterPopover({
                                                                isSet: true,
                                                                isShowView: false,
                                                                isShowFilter: true,
                                                            })
                                                        );
                                                    }}
                                                >
                                                    <Counter>
                                                        <CounterNumber>
                                                            {`+ ${
                                                                appliedFilters.length -
                                                                maxVisible
                                                            }`}
                                                        </CounterNumber>
                                                    </Counter>
                                                </ExtraContainer>
                                            )}
                                    </FilterDetailsContainer>
                                ) : null}
                            </FilterContainer>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={2}
                            md={2}
                            lg={2}
                            xl={2}
                            mobile={12}
                            style={{ backgroundColor: '#f5f5f5' }}
                        >
                          {clearFilterFlag &&  <ClearFilterDesktop
                                marginLeftTemplate={marginLeftTemplate}
                                onClick={handleClearClick}
                                marginBottomTemplate={marginBottomTemplate}
                            >
                                {t('physicians.filterResults.clearFilters')}
                            </ClearFilterDesktop>}
                        </Grid>
                    </Grid>
                </FilterOptionSelect>
            ) : null}
        </>
    );
};

export default FilterResultsPanel;
